import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiService, LoginResponse, Usuario } from '../../api.service';

@Injectable({ providedIn: 'root' })
export class ServicoAutenticacao {
  private readonly chaveToken = 'pontojwm_token';
  private usuarioAtual?: Usuario;

  constructor(private readonly api: ApiService) {}

  get usuarioLogado() {
    return this.usuarioAtual;
  }

  get token() {
    return localStorage.getItem(this.chaveToken) || '';
  }

  get possuiToken() {
    return Boolean(this.token);
  }

  entrar(email: string, senha: string, slugTenant?: string): Observable<LoginResponse> {
    return this.api.login(email, senha, slugTenant).pipe(
      tap(response => this.aplicarLogin(response.token, response.usuario))
    );
  }

  criarPrimeiroAcesso(usuario: Usuario): Observable<LoginResponse> {
    return this.api.bootstrap(usuario).pipe(
      tap(response => this.aplicarLogin(response.token, response.usuario))
    );
  }

  carregarSessao(): Observable<Usuario> {
    return this.api.me().pipe(
      tap(usuario => this.usuarioAtual = usuario)
    );
  }

  verificarPrimeiroAcesso() {
    return this.api.bootstrapDisponivel();
  }

  montarUsuarioPrimeiroAcesso(email: string, senha: string): Usuario {
    return {
      nome: email || 'Administrador',
      email,
      senha,
      perfil: 'ADMIN_GLOBAL',
      ativo: true
    };
  }

  aplicarLogin(token: string, usuario: Usuario) {
    localStorage.setItem(this.chaveToken, token);
    this.usuarioAtual = usuario;
  }

  sair() {
    localStorage.removeItem(this.chaveToken);
    this.usuarioAtual = undefined;
  }
}
